<template>
  <!-- 公开课卡片组件 -->
  <div class="course-card">
    <router-link class="course-link" :to="{name: 'publicClassDetail', params: {id: item.id}}">
      <div class="course-cover background-logo">
        <img class="cover-image" src="" v-lazy="item.thumb">
      </div>
      <div class="course-info">
        <div class="course-title">
          <div class="title">{{item.title}}</div>
          <div class="course-status">
            <span class="signing" v-if="status == 1">报名中...</span>
          </div>
        </div>
        <div class="studio-info">
          <div class="teacher-name">{{authorStr}}</div>
          <div class="course-date" v-if="status == 1">上课时间：{{formatCourseStart}}</div>
          <div class="course-date" v-else>{{formatCourseStart}}</div>
        </div>
      </div>
    </router-link>
  </div>

</template>

<style lang="less" scoped></style>

<script>
  import Utils from '@/untils/utils'
  export default {
    props: {
      item: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {}
    },
    computed: {
      formatCourseStart() {
        // 格式化公开课开课时间
        const courseStartTime = this.item.starttime * 1000;
        if (this.item.starttime > new Date().getTime() / 1000) {
          return `${Utils.formatTimeToDay(new Date(courseStartTime))} ${Utils.formatTimeToMoinute(new Date(courseStartTime))}`;
        }else {
          return '看回放';
        }
      },
      status() {
        // 课程状态 1：报名中 0：已结束
        return (this.item.starttime > new Date().getTime() / 1000) ? 1 : 0;
      },
      authorStr() {
        let authors = []
        if(this.item.author && this.item.author.length > 0) {
          this.item.author.forEach(item => {
            authors.push(item.name)
          })
        }
        return authors.length > 0 ? authors.join(',') : '';
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Course/Cards/publicClassCard.vue